export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyDcjtj4EOPvQRRaU3RMHulStio8HTULMKs",
    authDomain: "secondbrand-1.firebaseapp.com",
    databaseURL: "https://secondbrand-1-default-rtdb.firebaseio.com",
    projectId: "secondbrand-1",
    storageBucket: "secondbrand-1.appspot.com",
    messagingSenderId: "148586921572",
    appId: "1:148586921572:web:c215e6ff7b11dcdcbbe971"
};
